export const userRequiredPermissionName = 'reportconfig.user';
